import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listCourses, paymentCatalog } from "../lib/api";
import { useLang } from "../i18n/LanguageContext";
import { ArrowRight, BookOpen, Users, Clock } from "lucide-react";

const Academy = () => {
  const { lang } = useLang();
  const [courses, setCourses] = useState([]);
  const [catalog, setCatalog] = useState({});

  useEffect(() => {
    listCourses(lang).then(setCourses);
    paymentCatalog().then(setCatalog);
  }, [lang]);

  return (
    <div className="pt-28 min-h-screen" data-testid="academy-page">
      <div className="container-sat pt-8 pb-12">
        <div className="overline mb-4">SAT · Academy</div>
        <h1 className="headline-xl text-5xl md:text-7xl">Lerne die Spielregeln des Lebens.</h1>
        <p className="serif italic text-xl text-white/55 mt-6 max-w-2xl">Geführte Kurse, Module und Lektionen — designed, um wirklich etwas zu verändern.</p>
        <div className="flex gap-3 mt-8">
          <Link to="/academy/dashboard" className="btn-secondary text-sm" data-testid="academy-dashboard-link">Mein Dashboard <ArrowRight size={14} /></Link>
          <Link to="/auth/register" className="btn-ghost text-sm">Konto anlegen</Link>
        </div>
      </div>

      <section className="py-16 bg-[#050B1B]">
        <div className="container-sat">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="academy-courses-grid">
            {courses.map((c) => {
              const totalLessons = (c.modules || []).reduce((acc, m) => acc + (m.lessons?.length || 0), 0);
              const totalMinutes = (c.modules || []).reduce((acc, m) => acc + (m.lessons || []).reduce((s, l) => s + (l.duration_min || 0), 0), 0);
              return (
                <Link
                  key={c.id}
                  to={`/academy/${c.slug}`}
                  className="group relative overflow-hidden rounded-2xl border border-white/8 bg-[#0E1A30] hover:border-white/20 transition"
                  data-testid={`course-card-${c.slug}`}
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    {c.cover_image && (
                      <img src={c.cover_image} alt="" className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition duration-700" />
                    )}
                  </div>
                  <div className="p-6">
                    <div className="flex items-center justify-between text-xs">
                      <span className="overline">{c.track === "mentor" ? "Mentor-Ausbildung" : c.track === "corporate" ? "Corporate" : "Academy"}</span>
                      <span className="text-[#D4AF37]">{c.price_chf > 0 ? `CHF ${c.price_chf.toFixed(0)}` : "Kostenlos"}</span>
                    </div>
                    <h3 className="serif text-2xl mt-3 font-light leading-tight">{c.title}</h3>
                    <p className="text-white/55 text-sm mt-2 line-clamp-2">{c.subtitle}</p>
                    <div className="flex gap-4 text-xs text-white/45 mt-4">
                      <span className="flex items-center gap-1"><BookOpen size={12} /> {c.modules?.length || 0} Module</span>
                      <span className="flex items-center gap-1"><Clock size={12} /> {totalMinutes} min</span>
                      <span className="flex items-center gap-1"><Users size={12} /> {totalLessons} Lektionen</span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Academy;
